import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    Input,
    OnInit,
    Renderer2,
    TemplateRef,
    ViewChild,
} from '@angular/core';

import { NavigationService } from './../navigation.service';

import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { WINDOW } from 'src/app/core/http/window.providers';
import { SetupService } from '@core/services/setup';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
    public isCollapsed: boolean;
    public activeRoute: string;
    hamburger = faBars;
    production: boolean = false;

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];
    loaded: boolean = false;

    @Input('type') type: string;
    navbarTemplate: TemplateRef<any>;
    @ViewChild('navbarDefault') template01: TemplateRef<any>;
    @ViewChild('navbarSimple') template02: TemplateRef<any>;
    @ViewChild('navbarCentered') template03: TemplateRef<any>;
    @ViewChild('navRootEl') navRoot: ElementRef;

    constructor(
        private router: Router,
        private navigationService: NavigationService,
        private cdRef: ChangeDetectorRef,
        public setupService: SetupService,
        private renderer: Renderer2,
        @Inject(WINDOW) public window: Window
    ) {
        // Inicializar encolhido
        this.isCollapsed = true;
    }

    ngOnInit(): void {
        this.getMenu();

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => (this.activeRoute = event.url));
    }

    ngAfterViewInit() {
        this.defineTemplate();
        this.cdRef.detectChanges();
    }

    defineTemplate() {
        switch (this.type) {
            case '1':
                this.navbarTemplate = this.template01;
                break;
            case '2':
                this.navbarTemplate = this.template02;
                break;
            case '3':
                this.navbarTemplate = this.template03;
                break;
            default:
                this.navbarTemplate = this.template01;
                break;
        }
    }

    /**
     * onDropClick - abre/fecha dropdown quando mobile
     * @param {dropdown: NgbDropDown}
     */
    onDropClick(dropdown: NgbDropdown) {
        dropdown.close();
        if (this.window.innerWidth < 992) {
            this.toggleCollapse();
        }
        
    }

    onDropMouseEnter(dropdown: NgbDropdown) {
        if (dropdown.isOpen()) return;
        dropdown.open();
    }

    onDropMouseLeave(dropdown: NgbDropdown) {
        dropdown.close();
    }

    onItemMouseLeave(dropDepto, $event) {
        if ($event.relatedTarget?.closest('.dropdown-nav-menu')) return;
        dropDepto.close();
    }
    onItemClick(item) {
        
        if (this.window.innerWidth < 992 && !item.subItens?.length) {
            this.toggleCollapse();
        }
    }

    departmentActiveRoute() {
        let active = false;
        if (!this.activeRoute) return;
        const departmentRoutes = [
            'kids',
            'youth',
            'wheelchair',
            'professional',
            'senior',
            'classes',
            'beachtennis',
            'coachtraining',
            'arbitration',
        ];

        for (let route of departmentRoutes) {
            if (this.activeRoute.includes(route)) {
                active = true;
                break;
            }
        }
        return active;
    }

    /**
     * getMenu() - Buscar itens do menu horizontal
     */
    getMenu() {
        this.navigationService.getMenuHeader().subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
        if (this.isCollapsed) {
            this.renderer.removeClass(this.window.document.body, 'overflow-hidden');
        } else {
            this.renderer.addClass(this.window.document.body, 'overflow-hidden');
        }
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.loaded = true;
        this.production = this.window.location.hostname !== 'localhost';

        setTimeout(() => {
            if (this.navbarTemplate === this.template03) {
                this.renderer.addClass(this.navRoot.nativeElement, 'nav-root--centered');
            }
        }, 100);

        //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }
}
